import PropTypes from "prop-types";
import { Divider, Skeleton } from "@mantine/core";
import {
  formatKES,
  EMPTY_FIELD_PLACEHOLDER,
} from "../../../../utils/transactionutils";

function SummaryItem({ label, value, isLoading, isError, valueClassName }) {
  return (
    <div className="flex items-center gap-1.5">
      <span className="text-sm text-gray-400">{label}:</span>
      {isLoading ? (
        <Skeleton height={14} width={80} radius="sm" />
      ) : (
        <span className={`text-sm font-semibold ${valueClassName}`}>
          {isError ? EMPTY_FIELD_PLACEHOLDER : value}
        </span>
      )}
    </div>
  );
}

SummaryItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  valueClassName: PropTypes.string,
};

function BatchTransactionsSummaryFooter({
  subtotal,
  totalCharges,
  grandTotal,
  isLoading = false,
  isError = false,
}) {
  return (
    <div>
      <Divider color="gray.2" />
      <div className="flex flex-wrap justify-end gap-x-8 gap-y-2 pt-3">
        <SummaryItem
          label="Subtotal"
          value={formatKES(subtotal)}
          isLoading={isLoading}
          isError={isError}
          valueClassName="text-gray-900"
        />
        <SummaryItem
          label="Total Charges"
          value={formatKES(totalCharges)}
          isLoading={isLoading}
          isError={isError}
          valueClassName="text-gray-900"
        />
        <SummaryItem
          label="Grand Total"
          value={formatKES(grandTotal)}
          isLoading={isLoading}
          isError={isError}
          valueClassName="text-primary-700"
        />
      </div>
    </div>
  );
}

BatchTransactionsSummaryFooter.propTypes = {
  subtotal: PropTypes.number,
  totalCharges: PropTypes.number,
  grandTotal: PropTypes.number,
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
};

export default BatchTransactionsSummaryFooter;
